import React from 'react';
import defaultImage from 'features/Login/assets/bg-default.png';
import { DOMAIN_PATH } from 'configs/main';
import { byPlatform } from 'utils/platforms';
import styled from 'styled-components';

const VIDEO_TAG_WARNING = 'Your browser does not support the video tag.';

const HeaderWithBanner = styled.div`
    height: 100%;
    position: relative;
    width: 100%;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    background: linear-gradient(transparent, transparent 20%, rgb(255, 255, 255) 54%) center top / contain no-repeat, url('${(
        props
    ) => props.imgPath}') center top / 120% 60% rgb(255, 255, 255);
    background-repeat: no-repeat;
    @media (orientation: landscape) {
        background-size: cover;
    }
    @media (min-device-width: 700px)  {
        background-size: cover;
    }
`;

const HeaderBanner = ({ authUIConfig, authUIConfigRequestError, children }) => {
    const uiLoginConfig = authUIConfig
        ? authUIConfig.find((item) => item.area === 'login')
        : null;

    // const renderVideo = (uiLoginConfig) => (
    //     <video
    //         autoPlay
    //         muted
    //         loop
    //         playsInline
    //         height="100%"
    //         style={{
    //             transform: 'scale(2.5)',
    //         }}
    //     >
    //         <source src={DOMAIN_PATH + uiLoginConfig.video} type="video/mp4" />
    //         {VIDEO_TAG_WARNING}
    //     </video>
    // );

    const getTopImagePath = () =>
        DOMAIN_PATH +
        byPlatform(
            uiLoginConfig.image,
            undefined,
            undefined,
            uiLoginConfig.landscape_image
        );

    return (
        <HeaderWithBanner
            imgPath={
                authUIConfigRequestError || !uiLoginConfig
                    ? defaultImage
                    : getTopImagePath()
            }
        >
            {children}
        </HeaderWithBanner>
    );
};

export default HeaderBanner;
